module.exports = __webpack_public_path__ + "img/spin_btn.47eb74df.png";